import React from 'react'
import { xfersTheme } from './theme'
import NormalizeStyles from './NormalizeStyles'

const ThemeContext = React.createContext(xfersTheme)

type ThemeProviderProps = { children: React.ReactChild }
const ThemeProvider = ({ children }: ThemeProviderProps) => {
  return (
    <ThemeContext.Provider value={xfersTheme}>
      <NormalizeStyles />
      {children}
    </ThemeContext.Provider>
  )
}

const useTheme = () => {
  const context = React.useContext(ThemeContext)
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}

export { ThemeProvider, useTheme }
